import React, { useState, useEffect } from "react";
import PublicCatalogLayout from "@/layouts/PublicCatalogLayout"
import { fetchAPI } from "@/utility/NetworkUtils";
import {
  DataGridPremium
} from "@mui/x-data-grid-premium";
import DataGridTableToolbar from "@/utility/DataGridTableToolbar";
import { Link, Button } from "@mui/material";
import ItemForm from "../../items/form/ItemForm";
import ItemFormRevised from "@/items/form/ItemFormRevised";
const InventoryItemEdit = ({
  renter,
  item,
  user,
  renters
}) => {

  const [ categories, setCategories ] = useState([]);

  useEffect(() => {
    fetchCategories()
  }, [])
  
  fetchCategories = async () => { 
    fetchAPI(`/webapi/categories/all`, (json)=> {
      if (!json.errors) {
        setCategories(json.categories)
      } else {
        console.log({
          errors: json.errors
        })
      }
    });
  } 

  
  return (
    <PublicCatalogLayout
      classNames={{container: 'inventory-dashboard'}}
      className="inventory-dashboard"
      renter={renter}
      currentPage={renter ? "inventory-"+renter.id : ""}
      user={user}
      disableGroups={true}
      breadcrumbs={[
        renter && renter.id != 'all' ? {name: `${renter.name} Inventory`, url: `/inventory/${renter.id}`} : {name: "Inventory", url: `/`},
        {name: `${item.draft ? "New Item" : "Edit"}`}
      ]}
    >
      <div class="row">
        <div class="col-xs-12">
          <h1 class="catalog-h1">
            {item.draft ? "New Item" : item.name}
          </h1>
        </div>
      </div>
      <ItemFormRevised
        item={item}
        user={user}
        renter={renter}
        
      />
    </PublicCatalogLayout>
  );
}

export default InventoryItemEdit